// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import useUuid from '../../../../hooks/useUuid';

const vw = 564;
const vh = 85;

const StyledMask = styled.rect`
  transform-origin: right;

  ${({ $progressRatio, $transitionDuration }) => css`
    transition: transform ${$transitionDuration}ms ease-in-out;
    transform: scaleX(${1 - $progressRatio});
  `}
`;

type GRProgressBarSvgAsComponentProps = {
  className?: string;
  key?: string;
  progressRatio?: number;
  transitionDuration?: number;
};

const GRProgressBarSvgAsComponent = ({
  className,
  key,
  progressRatio = 0,
  transitionDuration = 300,
}: GRProgressBarSvgAsComponentProps) => {
  const uuid = useUuid();
  // eslint-disable-next-line sonarjs/no-nested-template-literals
  const uniqueIdentifier = `${uuid}${key ? `__${key}` : ''}`;

  return (
    <svg className={className} viewBox={`0 0 ${vw} ${vh}`} fill="none" xmlns="http://www.w3.org/2000/svg">
      <clipPath id={`gradient-mask-${uniqueIdentifier}`}>
        <path d="M25.8586 73L18 49.8L546 15V73H25.8586Z" />
      </clipPath>

      <path d="M558 3V84L17.0108 84L4.99994 42.3429L558 3Z" fill="black" />
      <path d="M25.8586 73L18 49.8L546 15V73H25.8586Z" fill={`url(#linear-gradient-${uniqueIdentifier})`} />

      <g clipPath={`url(#gradient-mask-${uniqueIdentifier})`}>
        <StyledMask
          width={`${vw}`}
          height={`${vh}`}
          fill="black"
          $progressRatio={progressRatio}
          $transitionDuration={transitionDuration}
        />
      </g>

      <defs>
        <linearGradient
          id={`linear-gradient-${uniqueIdentifier}`}
          x1="10"
          y1="76"
          x2="556"
          y2="76"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.392523" stopColor="#9C1200" />
          <stop offset="1" stopColor="#F98929" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GRProgressBarSvgAsComponent;
